import LotDetails from './LotDetails.jsx';

export default LotDetails;
